import { createUserStorage, STORE_STORAGE_KEYS } from "@ecommerce/shared-utils";

export const userStorage = createUserStorage({
    storageKey: STORE_STORAGE_KEYS.user,
});

/*
  Limpieza de una sola vía del storage anterior de Voda. El refresh token
  de tienda sólo puede existir en la cookie HttpOnly aislada por suscripción.
*/
if (typeof window !== "undefined") {
    window.localStorage.removeItem(STORE_STORAGE_KEYS.tokens);
}
